// extracted by mini-css-extract-plugin
export default {"decorator_body":"Decorator_decorator_body__0dtG5"};